module.exports = __webpack_public_path__ + "static/xtraCHEF-ae47741b2cccfad55947e3a7216a0ac9.jpg";